import { RootState } from 'editor/src/store';

const getECommerceProduct = (state: RootState) => state.variants.eCommerceProduct;

export default getECommerceProduct;
